import { createShallowStore, createStore } from '@frontend/store';

type OverlappingAppointmentType = Record<string, string>;

type State = {
  appointments: OverlappingAppointmentType[];
  isPanelVisible: boolean;
};

type Actions = {
  setAppointments: (appointments: OverlappingAppointmentType[]) => void;
  setIsPanelVisible: (isVisible: boolean) => void;
};

const initialState: State = {
  appointments: [],
  isPanelVisible: false,
};

type ScheduleAppointmentInfoPanelStore = State & Actions;

const useStore = createStore<ScheduleAppointmentInfoPanelStore>(
  (set) => ({
    ...initialState,
    setAppointments: (appointments) => set({ appointments }),
    setIsPanelVisible: (isVisible) => set({ isPanelVisible: isVisible }),
  }),
  {
    name: 'ScheduleAppointmentInfoPanelStore',
    enabled: true,
    trace: true,
  }
);

export const useScheduleAppointmentInfoPanelShallowStore = createShallowStore(useStore);

// TODO: reset store on location change
